import { render, staticRenderFns } from "./bulk-delete-keywords.component.html?vue&type=template&id=c3ef976e&scoped=true&external"
import script from "./bulk-delete-keywords.component.vue?vue&type=script&lang=ts"
export * from "./bulk-delete-keywords.component.vue?vue&type=script&lang=ts"
import style0 from "./bulk-delete-keywords.component.css?vue&type=style&index=0&id=c3ef976e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ef976e",
  null
  
)

export default component.exports